import axiosInstance from "../config/axiosInstance";
import { ENDPOINTS } from "../config/apiConfig";

export const fetchFormData = async (userId: any, page: any, limit: any) => {
  try {
    const response = await axiosInstance.get(
      ENDPOINTS.engagementHistoryData + "/listFormData",
      {
        params: {
          page,
          limit,
        },
      }
    );
    return response.data; // Assuming the API returns JSON data
  } catch (error) {
    console.error("Error fetching form data:", error);
    throw error; // Propagate the error for handling in the component
  }
};

export const getFilePreview = async (
  blob_file_name: any,
  request_from: any
) => {
  try {
    const response = await axiosInstance.get(
      ENDPOINTS.engagementHistoryData + "/getFilePreview",
      {
        params: {
          blob_file_name: blob_file_name,
          request_from: request_from,
        },
        responseType: "blob", // 👈 this is key
      }
    );
    return response;
    // return response.data;  // Assuming the API returns JSON data
  } catch (error) {
    console.error("Error fetching file preview:", error);
    throw error; // Propagate the error for handling in the component
  }
};

export const fetchDataByProjectId = async (
  projectId: string,
  userId: string
) => {
  try {
    const response = await axiosInstance.get(
      `${ENDPOINTS.engagementHistoryData}/findbyProjectId?project_id=${projectId}&user_id=${userId}`
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error: any) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data");
  }
};
